import {
  Component,
  model,
  ChangeDetectionStrategy,
  input,
} from '@angular/core';
import { FormValueControl } from '@angular/forms/signals';

@Component({
  selector: 's-form-field',
  imports: [],
  templateUrl: './s-form-field.component.html',
  styleUrl: './s-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[class.error]': '!!error()',
    '[class.outline]': 'errorType() === "outline" && !!error()',
    '[class.text]': 'errorType() === "text" && !!error()',
    '[class.outline-plus-text]':
      'errorType() === "outline-plus-text" && !!error()',
    '[class.disabled]': 'disabled()',
  },
})
export class SFormFieldComponent implements FormValueControl<string | number> {
  readonly value = model<string | number>('');
  readonly error = input<boolean | string | null>(null);
  readonly errorType = input<'outline' | 'text' | 'outline-plus-text'>(
    'outline-plus-text'
  );
  readonly disabled = input<boolean>(false);

  readonly label = input<string>('');
  readonly placeholder = input<string>('');
  readonly id = input<string>('');
}
